import Vue from 'vue';

export const DownloadDataRequestsApi = {
  create() {
    return Vue.http.post("/api/customers/download_data_requests")
  },
}